import React, { useState } from "react";
import AreaChart from "../../../Charts/AreaChart";
import Skeleton from "react-loading-skeleton";
import trans from "../../../../utils";
import TotalPopup from "./TotalPopup/TotalPopup";
import "react-loading-skeleton/dist/skeleton.css";

export default function TotalComponent(props) {
  const [totalPopup, setTotalPopup] = useState("");

  const isDataReady = props.data && props.labels;

  return (
    <>
      <div
        className={`dashboard-total cursor ${props.style}`}
        onClick={() => setTotalPopup(props.title)}
      >
        <div className="flex-between">
          <div>
            <p className="fs-16 fw-600 neutral-500">{trans(props.title)}</p>
            {isDataReady ? (
              <div className="mb-3 flex-row">
                {props.type === "money" ? (
                  <img
                    className="me-2"
                    src={
                      props.percent > 0
                        ? `${process.env.PUBLIC_URL}/assets/incbad.svg`
                        : `${process.env.PUBLIC_URL}/assets/decgood.svg`
                    }
                    alt=""
                  />
                ) : (
                  <img
                    className="me-2"
                    src={
                      props.percent > 0
                        ? `${process.env.PUBLIC_URL}/assets/Increase.svg`
                        : `${process.env.PUBLIC_URL}/assets/Decrease.svg`
                    }
                    alt=""
                  />
                )}
                {props.type === "money" ? (
                  <div className="fs-12">
                    <span
                      className={`fw-700 me-1 ${
                        props.percent > 0 ? "danger" : "brand-500"
                      }`}
                    >
                      {props.percent > 0
                        ? `${props.percent}%`
                        : `${Math.abs(props.percent)}%`}{" "}
                    </span>
                    {props.percent > 0
                      ? trans("exceeded last month")
                      : trans("saved / to last month")}
                  </div>
                ) : (
                  <div className="fs-12">
                    <span
                      className={`fw-700 ${
                        props.percent > 0 ? "brand-500" : "danger"
                      }`}
                    >
                      {props.percent > 0
                        ? `${props.percent}`
                        : Math.abs(props.percent)}{" "}
                    </span>
                    {props.percent > 0
                      ? trans("more than last month")
                      : trans("less than last month")}
                  </div>
                )}
              </div>
            ) : (
              <div className="mb-3 flex-center">
                <Skeleton circle width={30} height={30} className="me-3" />
                <Skeleton width={100} height={20} />
              </div>
            )}
            <div className="flex-center">
              <span className="fs-18 fw-600">
                {props.number === "Loading..." ? (
                  <Skeleton width={50} height={30} />
                ) : props.type === "money" ? (
                  `${props.number} ${trans("AED")}`
                ) : (
                  props.number
                )}
              </span>
              <div className="dashboard-total-chart">
                {isDataReady ? (
                  <AreaChart
                    data={props.data}
                    color={props.color}
                    labels={props.labels}
                    chartName={trans(props.title)}
                  />
                ) : (
                  <Skeleton width={150} height={60} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {totalPopup && (
        <TotalPopup title={totalPopup} setTotalPopup={setTotalPopup} />
      )}
    </>
  );
}
